import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PagerHtmlItem = _resolveComponent("PagerHtmlItem")!
  const _component_PagerLinkItem = _resolveComponent("PagerLinkItem")!

  return (_ctx.isHtmlItem)
    ? (_openBlock(), _createBlock(_component_PagerHtmlItem, {
        key: _ctx.keyPrefix + '-html',
        "pager-item": _ctx.pagerItem as PHI
      }, null, 8, ["pager-item"]))
    : (_openBlock(), _createBlock(_component_PagerLinkItem, {
        key: _ctx.keyPrefix + '-link',
        "pager-item": _ctx.pagerItem as PLI
      }, null, 8, ["pager-item"]))
}